import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c652e1f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c652e1f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c652e1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c652e1f8')) {
      api.createRecord('c652e1f8', component.options)
    } else {
      api.reload('c652e1f8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c652e1f8&scoped=true", function () {
      api.rerender('c652e1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wx-material/index.vue"
export default component.exports